import { useEffect } from 'react'
import { appSlice } from '@/store/appSlice'
import { FpsMeter } from '@/utils/debug/fpsMeter'
import { useAppSelector } from './store'

export function useFpsMeter(isCanvasReady: boolean) {
  const debugMode = useAppSelector(appSlice.selectors.debugMode)

  useEffect(() => {
    let fpsMeter: FpsMeter | null = null

    if (debugMode && isCanvasReady) {
      const el = document.getElementById('fps-meter')
      if (!el) {
        return
      }

      fpsMeter = new FpsMeter(el)
      fpsMeter.start()
    }

    return () => {
      if (fpsMeter) {
        fpsMeter.stop()
      }
    }
  }, [debugMode, isCanvasReady])
}
